import { render, staticRenderFns } from "./RiwayatDraft.vue?vue&type=template&id=37beea09&scoped=true"
import script from "./RiwayatDraft.vue?vue&type=script&lang=js"
export * from "./RiwayatDraft.vue?vue&type=script&lang=js"
import style0 from "./RiwayatDraft.vue?vue&type=style&index=0&id=37beea09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37beea09",
  null
  
)

export default component.exports